// extracted by mini-css-extract-plugin
export default {"container":"Item_container__DTbC0","content":"Item_content__Np4ZA","summary":"Item_summary__02aSQ"};